import { render, staticRenderFns } from "./addTopic.vue?vue&type=template&id=1c43d74c&scoped=true&"
import script from "./addTopic.vue?vue&type=script&lang=js&"
export * from "./addTopic.vue?vue&type=script&lang=js&"
import style0 from "./addTopic.vue?vue&type=style&index=0&id=1c43d74c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c43d74c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c43d74c')) {
      api.createRecord('1c43d74c', component.options)
    } else {
      api.reload('1c43d74c', component.options)
    }
    module.hot.accept("./addTopic.vue?vue&type=template&id=1c43d74c&scoped=true&", function () {
      api.rerender('1c43d74c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dynamic/communityDynamic/communityDynamicHome/components/addTopic.vue"
export default component.exports